"use client"

import { usePathname } from 'next/navigation'
import { Navbar } from './navbar'
import path from 'path'

export function ConditionalNavbar() {
  const pathname = usePathname()

  // Don't show navbar on authenticated routes (they have their own dashboard headers)
  const isAuthenticatedRoute = pathname.startsWith('/dashboard') ||
    pathname.startsWith('/profile') ||
    pathname.startsWith('/settings') ||
    pathname.startsWith('/assignments') ||
    pathname.startsWith('/analytics') ||
    pathname.startsWith('/scorer') ||
    pathname.startsWith('/report') ||
    pathname.startsWith('/previous-marks') ||
    pathname.startsWith('/help') ||
    pathname.startsWith('/ai-detection') ||
    pathname.startsWith('/referral') ||
    pathname.startsWith('/topic-generator') || pathname.startsWith('/survey-filler')
  // Don't show navbar on internals/admin routes (they have admin sidebar)
  const isInternalsRoute = pathname.startsWith('/internals') || pathname.startsWith('/internal')

  // Don't show navbar on affiliate routes (they have affiliate sidebar)
  const isAffiliateRoute = pathname.startsWith('/affiliate/')

  // Don't show navbar on auth pages (login/signup pages)
  const isAuthPage = pathname.startsWith('/auth/')

  // Hide navbar on these routes
  if (isAuthenticatedRoute || isInternalsRoute || isAffiliateRoute || isAuthPage) {
    return null
  }

  // Show navbar on all public routes (/, /about, /faq, /results, etc.)
  return <Navbar />
}